import { render, staticRenderFns } from "./ItemAdminObjective.vue?vue&type=template&id=2031b02a&"
import script from "./ItemAdminObjective.vue?vue&type=script&lang=js&"
export * from "./ItemAdminObjective.vue?vue&type=script&lang=js&"
import style0 from "./ItemAdminObjective.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports